module.exports = __webpack_public_path__ + "static/media/pic-card_debit.b9217e20.png";